import React from "react"

import type { Appointments } from "@/lib/appointments"
import { buildAppointmentsPerformResults } from "@/lib/appointments/buildPerformResults"
import { contextPlaceholderFunction } from "@/lib/context/placeholderFunction"

export const AppointmentsContext =
  React.createContext<Appointments.ContextData>({
    perform: contextPlaceholderFunction,
    processing: `loading`,
    results: buildAppointmentsPerformResults(),
  })
